// AssumptionsStep — volatility / T / risk-free / dividend (F3.2, F3.4, F3.5, F3.6). Step 5.

import { ScrubInput } from 'calc-controls';
import { useActiveValuation, useStore } from '../../store/selectors';
import { Field } from '../common/Field';
import { VolatilityEstimator } from './VolatilityEstimator';
import { RiskFreeLookup } from './RiskFreeLookup';

export function AssumptionsStep() {
  const active = useActiveValuation();
  const setAssumptions = useStore((s) => s.setAssumptions);
  if (!active) return null;
  const a = active.inputs.assumptions;
  return (
    <div className="card">
      <div className="card-title">Assumptions</div>
      <div className="headline-grid">
        <Field
          label="Time to Liquidity (years)"
          htmlFor="ttl"
          helpText="Expected years until a liquidity event (IPO, sale). Drives the Black-Scholes horizon T and the risk-free-rate tenor."
        >
          <ScrubInput
            inline
            value={a.timeToLiquidity}
            onChange={(timeToLiquidity) =>
              setAssumptions(active.valuationId, { timeToLiquidity })
            }
            min={0.5}
            max={20}
            step={0.5}
            decimals={1}
          />
        </Field>
        <Field
          label="Dividend Yield"
          htmlFor="div"
          helpText="Annual dividend yield as a ratio (q in Black-Scholes). Use 0 for typical pre-IPO startups that pay no dividend."
        >
          <ScrubInput
            inline
            value={a.dividendYield}
            onChange={(dividendYield) =>
              setAssumptions(active.valuationId, { dividendYield })
            }
            min={0}
            max={0.2}
            step={0.001}
            decimals={3}
          />
        </Field>
      </div>
      <div className="mt-4">
        <div className="card-title" style={{ fontSize: 'var(--font-size-2)' }}>
          Volatility Estimation
        </div>
        <VolatilityEstimator
          volatility={a.volatility}
          onChange={(volatility) => setAssumptions(active.valuationId, { volatility })}
        />
      </div>
      <div className="mt-4">
        <div className="card-title" style={{ fontSize: 'var(--font-size-2)' }}>
          Risk-Free Rate Lookup
        </div>
        <RiskFreeLookup
          timeToLiquidity={a.timeToLiquidity}
          riskFreeRate={a.riskFreeRate}
          onChange={(riskFreeRate) => setAssumptions(active.valuationId, { riskFreeRate })}
        />
      </div>
      {(a.volatility < 0.2 || a.volatility > 0.8) && (
        <p className="badge badge-warning mt-3">
          Volatility of {(a.volatility * 100).toFixed(0)}% is outside the typical [20%, 80%] range
          — VOLATILITY_OUTLIER. Verify this assumption before relying on the result.
        </p>
      )}
    </div>
  );
}
